var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sui-label',{attrs:{"color":_vm.color,"title":_vm.arrest.bankName}},[_vm._v(" "+_vm._s(_vm.arrest.bankName)+" "),(_vm.arrest.amount_of_min_wages)?_c('span',[_vm._v("(min)")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }